export const ID = '84D85C43-926D-4A5E-BC8E-900CD6BAE59A';

export const NAME = 'Icons: Stock';
